import { useEffect } from 'react'
import {
  Box,
  Checkbox,
  Dialog,
  FormControl,
  FormGroup,
  Typography,
} from '@material-ui/core'
import Image from 'components/image'
import LoadingButton from '../../../baby-ui/compounds/LoadingButton'
import { useDMEStore } from '../../store'
import useStyles from './styles'
import { formattedEstimate } from '../../views/ShippingEstimate.utils'
import { preCheckoutModalViewedEvent } from '../../events/preCheckoutModalViewedEvent'
import { useTracking } from '../../../lib/babylistHealthAnalytics'
import { useLayout } from '../Layout'

interface PreCheckoutWidgetProps {
  open: boolean
  onConfirm: () => void
  finalCheckoutLoading: boolean
}

const PreCheckoutWidget = ({
  open,
  onConfirm,
  finalCheckoutLoading,
}: PreCheckoutWidgetProps) => {
  const classes = useStyles()
  const store = useDMEStore()
  const tracker = useTracking()
  const layout = useLayout()

  const estimate = formattedEstimate(store.insurance.shippingEligibilityDays)

  useEffect(() => {
    preCheckoutModalViewedEvent(tracker)()
  }, [])

  return (
    <Dialog
      fullScreen
      PaperProps={{
        classes: {
          root: classes.dialogRoot,
        },
      }}
      open={open}
    >
      <div className={classes.dialogContent}>
        <div>
          <Typography
            gutterBottom
            className={classes.headerText}
            color="primary"
            variant="h6"
          >
            Some important things before you check out...
          </Typography>
          <Box
            className={classes.detailBox}
            sx={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
            }}
          >
            <Image
              className={classes.headerImage}
              height={64}
              src="//images.babylist.com/image/upload/v1685493034/DME/package_med.svg"
              width={43}
            />
            <Typography
              gutterBottom
              className={classes.subHeaderText}
              color="primary"
              variant="h5"
            >
              Your pump will ship {estimate} your due date.
            </Typography>
            <Typography
              gutterBottom
              className={classes.detailText}
              variant="body1"
            >
              Your insurance plan determines when we can ship your pump and
              shipping is always FREE.
            </Typography>
          </Box>
          <Box
            className={classes.detailBox}
            sx={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
            }}
          >
            <Image
              className={classes.headerImage}
              height={45}
              src="//images.babylist.com/image/upload/v1685493034/DME/paperwork_med.svg"
              width={60}
            />
            <Typography
              gutterBottom
              className={classes.subHeaderText}
              color="primary"
              variant="h5"
            >
              Insurance only covers one pump per pregnancy.
            </Typography>
            <Typography
              gutterBottom
              className={classes.detailText}
              variant="body1"
            >
              By placing your order, you are stating that this is the only
              breast pump you will order through insurance for this pregnancy.
            </Typography>
          </Box>
          {layout?.isFreeGiftEnabled && (
            <Box
              className={classes.detailBox}
              sx={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
              }}
            >
              <Image
                className={classes.headerImage}
                height={45}
                src="//images.babylist.com/image/upload/v1693322129/DME/check-mark.svg"
                width={60}
              />
              <Typography
                gutterBottom
                className={classes.subHeaderText}
                color="primary"
                variant="h5"
              >
                Get a free gift with your order!
              </Typography>
              <Box alignItems="center" display="flex">
                <FormControl>
                  <FormGroup>
                    <Checkbox
                      id="freeGift"
                      name="freeGift"
                      value={store.cart.includeFreeGift}
                      onChange={(_, checked) => {
                        store.cart.setIncludeFreeGift(checked)
                      }}
                    />
                  </FormGroup>
                </FormControl>
                <Typography
                  gutterBottom
                  className={classes.detailText}
                  component="label"
                  htmlFor="freeGift"
                  style={{ textAlign: 'left', margin: 0 }}
                  variant="body1"
                >
                  Yes, add the free, 120-count breast milk storage bags to my
                  cart.
                </Typography>
              </Box>
            </Box>
          )}

          <LoadingButton
            fullWidth
            className={classes.checkoutBttn}
            color="primary"
            loading={finalCheckoutLoading}
            variant="contained"
            onClick={onConfirm}
          >
            Got It
          </LoadingButton>
        </div>
      </div>
    </Dialog>
  )
}

export default PreCheckoutWidget
